import { onUnmounted, ref } from "@nuxtjs/composition-api";
function useScrollHint() {
  const isShowScrollHint = ref(false);
  let observer = null;
  const initScrollHintIntersection = (root, target) => {
    const options = {
      root,
      rootMargin: "0px",
      threshold: 1
    };
    const callback = (entries) => {
      entries.forEach((entry) => {
        const elementIsVisible = entry.isIntersecting && entry.intersectionRatio === 1;
        isShowScrollHint.value = !elementIsVisible;
      });
    };
    observer = new IntersectionObserver(callback, options);
    observer.observe(target);
  };
  const resetScrollObserver = () => {
    if (observer)
      observer?.disconnect();
    isShowScrollHint.value = false;
  };
  onUnmounted(() => {
    resetScrollObserver();
  });
  return {
    initScrollHintIntersection,
    isShowScrollHint,
    resetScrollObserver
  };
}
;
export {
  useScrollHint as default
};
